/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {};
    },
    mounted() { },
    methods: {
        ...mapActions({
            setResources: "setResources",
            removeResource: "removeResource",
            addNewResource: "addNewResource"
        })
    },
    computed: {
        ...mapGetters({
            getResources: "getResources"
        })
    }
};
